<div class="row">
	<div class="col-md-2"></div>
		<div class="col-md-8">
			<video width="100%" height="auto" controls autoplay>
			  <source src="/assets/videos/what_is_insomnia.mp4" type="video/mp4">
			Your browser does not support the video tag.
			</video>
		</div>
	<div class="col-md-2"></div>
</div>


<BR>



<p style="color : #002E46 !important;">
    Many of us think that insomnia merely implies the inability to fall asleep, when in fact, insomnia
    is defined as not being able to achieve any of the following:

</p>
<ul class="ion-text-left">
    <li style="color : #002E46 !important;">
        <strong>Falling asleep
        </strong>
    </li>
    <li style="color : #002E46 !important;">
        <strong>Staying asleep
        </strong>
    </li>
    <li style="color : #002E46 !important;">
        <strong> Getting a restful sleep
        </strong>
    </li>

</ul>


<p style="color : #002E46 !important;">
    It should also be noted that insomniacs experience some level of daytime impairment.
</p>
<br>
<mat-accordion class="example-headers-align" multi="false">


    <!---->
    <mat-expansion-panel class="ion-text-left">

        <mat-expansion-panel-header>
            <mat-panel-title style="font-weight: bold; color : #002E46 !important;">

                HOW COMMON IS INSOMNIA?
            </mat-panel-title>

        </mat-expansion-panel-header>


        <p style="color : #002E46 !important;">
            Insomnia is probably the most frequent health complaint following pain and headaches. Many
            studies suggest that about one third of adults experience insomnia at some time throughout
            their lives.

        </p>
        <br>

        <p style="color : #002E46 !important;">
            Insomnia affects people from all walks of life but is more frequent among women and the
            elderly. Unfortunately, with increasing societal and familial pressure, more younger people
            are now experiencing insomnia as well.
        </p>
        <br>
        <p style="color : #002E46 !important;">
            With the advancement of medical technology, we have been able to discover some significant
            information about the physiology of insomnia that may explain why insomniacs sleep poorly. For
            instance, insomniacs have greater physical tension--which is often triggered by mental tension
            during the night--compared to good sleepers, some have faster brain activity than good
            sleepers, and there is also evidence that insomniacs display a disruption of their daily body
            temperature rhythms relative to good sleepers.

        </p>

        <br>
        <p style="color : #002E46 !important;">

            Collectively the research suggests that insomniacs have improperly balanced sleep and
            wakefulness systems.
        </p>
        <br>

        <p style="color : #002E46 !important;">
            <strong> Does the following scenario sound familiar to you?</strong>

        </p>

        <br>
        <p style="color : #002E46 !important;">
            Imagine on some nights that your sleep system is just not ready for sleep. You are lying in
            bed and you are simply unable to fall asleep. Your mind starts wondering and racing. Then you
            start thinking and worrying about all the work that you need to accomplish… all of these
            thoughts will in-turn further stimulate your wakefulness system, causing more anxiety and
            stress. Lo and behold, it is already morning and you are exhausted.
        </p>
        <br>
        <p style="color : #002E46 !important;">

            This scenario is common among insomniacs and, over time, will trigger and escalate the
            feelings of loss of control.

        </p>
        <br>
        <p style="color : #002E46 !important;">
            It is crucial to recognize that occasional bouts of insomnia are normal and they are often an
            inevitable reaction to significant life events or chronic health problems. However, in dealing
            with these situations, we tend to develop coping mechanisms that help us get through our first
            sleepless nights, which soon turn into weeks, months, and then years of poor habits. If these
            maladaptive behaviors are maintained, they will hurt our sleep rather than improve it.
        </p>
        <br>
        <p style="color : #002E46 !important;">
            The good news is that there are several treatments for insomnia; both pharmacological and
            non-pharmacological. These treatments have been tested in several research studies and can be
            effective not only in the short term, but over longer periods of time as well.
        </p>

        <br>
        <p style="color : #002E46 !important;">
            The first type and the most important long-term treatment is behavioral treatment, or simply
            put the
            <strong> therapy that changes your behavior to change your sleep.</strong> The advantage of
            this type of treatment is that it does not involve medication and is generally effective and
            safe. This approach will also put you in charge of your sleep. The downside is that it may
            take several months to be effective. Therefore, a little patience and persistence is required.
            Although behavior can be hard to change, harvesting can be quite fruitful if one perseveres
            for the initial couple of months.
        </p>


        <br>
        <p style="color : #002E46 !important;">
            The second type of therapy is medication, either over the counter or prescribed. Medications
            such as sleeping pills can sometimes be used to help insomnia and they are effective in the
            short term. However, insomnia is most often a long-term problem, and the safety and
            effectiveness of sleeping pills can be a concern over the long term.
        </p>
        <br>
        <mat-card style="background-color: #e9f3f1;">
            <mat-card-content>
                <mat-card-header>
                    <mat-card-title style="font-weight: bold; color : #002E46 !important;" class="ion-text-center">Key Points
                    </mat-card-title>

                </mat-card-header>


                <p style="color : #002E46 !important;">
                    After a few nights of bad sleep, we tend to develop coping mechanisms that helps us get
                    through our first sleepless nights, which can soon turn into weeks, months and then years
                    of poor habits. If these maladaptive behaviors are maintained, they will hurt our sleep
                    rather than improve it.
                </p>
                <br>

                <p style="color : #002E46 !important;">
                    The good news is that if we can identify the behaviors that hurt our sleep then we can
                    start making changes to our behavior in order to help our sleep.
                </p>

                <br>


            </mat-card-content>
        </mat-card>



    </mat-expansion-panel>
    <!---->
</mat-accordion>